export const SarasDnDTypes = {
  CARD: 'card',

  //more types will come here as we use DnD for other purpose. eg: FILE
}
